import type { IconProps } from "../types";

/**
 * Razor: 髭剃りアイコン。lucide-react に存在しないため registry svgContent を逐語再現。
 */
export const Razor = ({
	size = 24,
	color = "currentColor",
	strokeWidth = 2,
	className,
	"aria-label": ariaLabel,
}: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth={strokeWidth}
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		role={ariaLabel ? "img" : undefined}
		aria-label={ariaLabel}
		aria-hidden={ariaLabel ? undefined : true}
	>
		<rect x="3" y="3" width="18" height="4" rx="1" />
		<line x1="12" y1="7" x2="12" y2="9" />
		<rect x="10" y="9" width="4" height="12" rx="1" />
		<line x1="10" y1="12" x2="14" y2="12" />
		<line x1="10" y1="15" x2="14" y2="15" />
		<line x1="10" y1="18" x2="14" y2="18" />
	</svg>
);
